// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"45279cb6","918":"a9e67812"}[chunkId] + ".chunk.js";
};